import Button from "@shared/v2/Button";
import { ProductFamilyIds } from "./constants";
import { Product } from "../Support/Account/AddOnsSupport/types";

const PLAN_TEXT_GRADIENT =
  "tw-bg-[linear-gradient(90deg,#59C4C4,#336E7B)] tw-bg-clip-text tw-text-transparent";

interface PlanCardProps {
  isRecommended?: boolean;
  onClick?: () => void;
  product: Product;
  isCurrent?: boolean;
  isUpgrade?: boolean;
}

const getButtonClass = (isRecommended?: boolean, isUpgrade?: boolean, isCurrent?: boolean) => {
  if (isCurrent) return "tertiary";
  if (isRecommended || isUpgrade) return "primary";
  return "secondary";
};

const ProductCard: React.FC<PlanCardProps> = ({ isRecommended, onClick, product, isCurrent, isUpgrade }) => {
  const wrapperClass = isRecommended
    ? "tw-bg-[linear-gradient(90deg,#59C4C4_-10.74%,#BFE7E7_106.38%)] tw-p-[2px] tw-rounded-[16px]"
    : "tw-rounded-[16px]";
  const cardClass = isRecommended
    ? "tw-bg-white tw-rounded-[14px] tw-flex-1 tw-flex tw-flex-col tw-gap-[16px] tw-p-[23px] tw-overflow-hidden tw-border-none tw-shadow-[-3px_11px_41px_0_rgba(89,196,196,0.20)]"
    : "tw-bg-white tw-rounded-[16px] tw-border-solid tw-border-[1.5px] tw-border-gray-10 tw-flex-1 tw-flex tw-flex-col tw-gap-[16px] tw-p-[24px] tw-overflow-hidden tw-shadow-[-3px_11px_20px_0_rgba(159,159,159,0.10)]";
  const titleClass = `tw-font-semibold tw-uppercase tw-tracking-[1.6px] ${isRecommended ? PLAN_TEXT_GRADIENT : ""}`;
  const priceClass = `${isRecommended ? PLAN_TEXT_GRADIENT : ""} tw-font-semibold tw-text-24d`;

  return (
    <div className={`tw-flex-1 tw-min-w-[250px] ${wrapperClass}`}>
      <div className={cardClass}>
        <div className="tw-flex tw-flex-col tw-gap-[6px]">
          <div className="tw-flex tw-justify-between tw-items-center">
            {!product.slug.startsWith(ProductFamilyIds.Opportunities) && (
              <span className={titleClass}>{product.tier}</span>
            )}
            <span
              className={`${isRecommended ? "" : "tw-invisible"} tw-bg-[#EEF9F9] tw-text-theme-primary tw-text-[10px] tw-font-semibold tw-uppercase tw-px-[12px] tw-py-[6px] tw-rounded-[4px]`}
            >
              Recommended
            </span>
          </div>
          <div>
            <span className={priceClass}>${product.details.unitPrice}</span>
            <span className="tw-font-normal tw-text-14d tw-text-gray-50"> / month</span>
          </div>
        </div>
        <div className="tw-bg-gray-5 tw-h-[1px] tw-w-full" />
        <div className="tw-flex tw-flex-col tw-gap-[8px]">
          {product.slug.startsWith(ProductFamilyIds.Opportunities) && (
            <>
              <div>
                Access to <b>Expireds, FSBO's,</b> and <b>Pre-Forclosure</b> data right within Brivity
              </div>
              <div>Call prospects with built in dialer</div>
              <div>Add leads seamlessly to your database</div>
            </>
          )}
          {product.details.trackingNumberMax && (
            <div>
              <b>{product.details.trackingNumberMax}</b>{" "}
              <span className="tw-text-gray-50">Tracking Numbers</span>
            </div>
          )}
          {product.details.minutesPerMonth && (
            <div>
              <b>{product.details.minutesPerMonth.toLocaleString()} minutes</b>{" "}
              <span className="tw-text-gray-50">/ month</span>
            </div>
          )}
          {product.details.overageMinutesPrice && (
            <div>
              <b>+{product.details.overageMinutesPrice * 100} cents</b>{" "}
              <span className="tw-text-gray-50">
                per minute over {product.details.minutesPerMonth?.toLocaleString()}
              </span>
            </div>
          )}
        </div>
        {onClick && (
          <>
            <div className="tw-bg-gray-5 tw-h-[1px] tw-w-full" />
            {/* @ts-expect-error props */}
            <Button
              size="medium"
              className={isCurrent ? "tw-italic !tw-normal-case" : ""}
              disabled={isCurrent}
              schema={getButtonClass(isRecommended, isUpgrade, isCurrent)}
              onClick={onClick}
            >
              {isCurrent ? "Your Current Plan" : "Select Plan"}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
